import { formatCurrency } from '../../../../utils/formatters.util';
import React, { memo, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { GoTriangleRight } from 'react-icons/go';
import classNames from 'classnames';
import { getRandomNumber } from '../../../../utils/helper.util';

const ItemPricing = ({ personalizationFees, personalizationBreakdown, quantity = 1 }) => {
  return (
    <div className='tw-block'>
      {/* <div className='tw-mt-4 tw-border-t tw-border-gray-300 tw-pt-4'> */}
      <ItemPricingLine
        label='Personalization Fees'
        value={personalizationFees > 0 ? formatCurrency(personalizationFees * quantity) : 'Free'}
        breakdown={personalizationBreakdown}
        labelClassName='tw-cursor-pointer'
        quantity={quantity}
      />
      {/* </div> */}
    </div>
  );
};

const ItemPricingLine = ({
  label,
  bottom = null,
  middle = null,
  value,
  quantity,
  breakdown = [],
  labelClassName = '',
  className = '',
}) => {
  const [breakdownExpanded, setBreakdownExpanded] = useState(false);

  const filteredBreakdown = (breakdown || []); // .filter((item) => item.value > 0);

  if (filteredBreakdown.length <= 0) return null;

  const onClick = () => {
    if (breakdown.length > 0) setBreakdownExpanded((prevState) => !prevState);
  };

  return (
    <>
      <div
        className={classNames(
          'tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2 tw-font-bold tw-text-brand-black',
          className
        )}>
        <div className='tw-flex tw-items-center tw-gap-1' onClick={onClick}>
          <p className={classNames('tw-mb-0 tw-text-sm tw-text-brand-black', labelClassName)}>{label}</p>
          {breakdown.length > 0 && (
            <div
              className={classNames('tw-transition-all tw-duration-200', {
                'tw-rotate-90': breakdownExpanded,
              })}>
              <GoTriangleRight size={12} className='tw-text-brand-black' />
            </div>
          )}
        </div>
        <div className='tw-flex tw-items-center tw-gap-2'>
          {middle && <div className='tw-text-gray-dark'>{middle}</div>}
          <p className='tw-mb-0 tw-text-sm tw-text-brand-black'>{value}</p>
        </div>
      </div>
      {bottom && <div className='tw-text-gray-dark'>{bottom}</div>}

      {breakdown.length > 0 && (
        <ul
          className={classNames('tw-overflow-x-hidden tw-pl-5 tw-transition-all tw-duration-200', {
            'tw-max-h-96': breakdownExpanded,
            'tw-max-h-0': !breakdownExpanded,
          })}>
          {breakdown.map((item) => (
            <li
              key={`${item.text}-${getRandomNumber()}`}
              className='tw-flex tw-items-center tw-justify-between tw-font-normal'>
              <span>{item.text}</span> <span>{item.value ? formatCurrency(item.value * quantity) : 'Free'}</span>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default memo(ItemPricing);
